var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{staticClass:"content-layout"},[_c('header',{staticClass:"content-header"},[_c('div',{staticClass:"row column"},[_vm._t("header")],2)]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1547e11a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/layouts/ContentLayout.vue
// module id = jw0G
// module chunks = 0